'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index = require('../../../../../../../node_modules/@radix-ui/react-dialog/dist/index.cjs');
var React = require('react');
var Typography_web = require('../../../atoms/Typography/Typography.web.cjs');
var Header_web_styles = require('./Header.web.styles.cjs');

/**
 * Modal Header component - displays title, subtitle and optional actions
 */ const Header = ({ title, subtitle, customCss, ...props })=>{
    const headerStyles = React.useMemo(()=>[
            Header_web_styles.header,
            customCss
        ], [
        customCss
    ]);
    return /*#__PURE__*/ jsxRuntime.jsx("div", {
        css: headerStyles,
        ...props,
        children: /*#__PURE__*/ jsxRuntime.jsxs("div", {
            children: [
                /*#__PURE__*/ jsxRuntime.jsx(index.Title, {
                    asChild: true,
                    children: /*#__PURE__*/ jsxRuntime.jsx(Typography_web.Typography, {
                        variant: "h3",
                        isMarginless: true,
                        children: title
                    })
                }),
                subtitle && /*#__PURE__*/ jsxRuntime.jsx(Typography_web.Typography, {
                    variant: "body",
                    isMarginless: true,
                    children: subtitle
                })
            ]
        })
    });
};

exports.Header = Header;
//# sourceMappingURL=Header.web.cjs.map
